










































































// TODO: перенести в общий css файл для стилей профиля
import './styles/styles.styl';

import { Button } from '@/pages/profile/components';
import { SettingsMixin } from '../../mixins';
import { Form, FormInput, Select } from '@/pages/profile/blocks';
import { Checkbox as FormCheckbox, Textarea } from '@/components/form';
import AppSvgIcon from '@/uikit/components/AppSvgIconNew';
import AddEditStudyPlaceBody from './components/AddEditStudyPlaceBody.vue';
import AddEditStudyPlaceHeader from './components/AddEditStudyPlaceHeader.vue';
import { IStudyPlace } from '@/pages/profile/views/study/types';

export default {
  name: 'Study',
  components: {
    Button,
    Form,
    FormInput,
    Select,
    FormCheckbox,
    Textarea,
    AppSvgIcon,
  },
  mixins: [SettingsMixin],
  data() {
    return {
      count: 1,
      study: [],
      isLoadReq: false,
      isServerReqError: false,
    };
  },
  computed: {
    educationLevelDict() {
      return this.$store.state.educationLevelDict;
    },
    educationTypeDict() {
      return this.$store.state.educationTypeDict;
    },
  },
  methods: {
    async removeItem(item: any) {
      const index = this.study.findIndex(
        (el: IStudyPlace) => el.id === item.id
      );
      if (!item.is_new) {
        const { data } = await this.$axiosInstance.post('places-study/delete', {
          data: {
            id: item.id,
          },
        });
        data.success ? this.study.splice(index, 1) : null;
      } else if (item.is_new) {
        this.study.splice(index, 1);
      }
    },

    showModal(newItem: IStudyPlace | any = {}) {
      const { educationTypeDict, educationLevelDict } = this;
      this.$ui.$modal.show('AddEditStudyPlace', {
        settings: {
          size: {
            width: '500px',
            maxWidth: '500px',
          },
        },
        bind: this, // контекст
        slots: {
          header: {
            component: AddEditStudyPlaceHeader,
            propsData: {
              title: newItem.id
                ? 'Редактирование места учебы'
                : 'Добавление места учебы',
            },
          },
          body: {
            component: AddEditStudyPlaceBody,
            propsData: {
              educationTypeDict: educationTypeDict.map(
                (el: Record<string, number>) => ({
                  text: el.name,
                  value: el.id,
                })
              ),
              educationLevelDict: educationLevelDict.map(
                (el: Record<string, number>) => ({
                  text: el.name,
                  value: el.id,
                })
              ),
              saveMethod: this.sendData,
              study: this.study,
            },
          },
        },
      });
    },

    initData() {
      this.$store.state.user.profile.places_study.length < 1
        ? (this.study = [])
        : (this.study = this.$store.state.user.profile.places_study.map(
            (el: any) => {
              return {
                ...el,
              };
            }
          ));
    },
    async sendData(payload: Array<IStudyPlace>) {
      this.isLoadReq = true;
      this.isServerReqError = false;
      try {
        await this.$store.dispatch('user/updateProfile', {
          places_study: payload,
        });
        this.initData();
        return payload;
      } catch (e) {
        this.isServerReqError = true;
        throw e;
      }
      this.isLoadReq = false;
    },
  },
  created() {
    this.initData();
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/study/Study.vue